module.exports = __webpack_public_path__ + "static/img/4.cd45016.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/21/zh/4.png
// module id = tAEU
// module chunks = 0